import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import i18n from "../../../../../components/global/i18n";
import {
  Card,
  TextContainer,
  Button,
  Link,
  Checkbox,
  Page,
  FooterHelp,
} from "@shopify/polaris";
import CsvUpload from "../import/CsvUpload";
import { TitleBar } from "@shopify/app-bridge-react";
import { useNavigate } from "react-router-dom";
import {
  useGetCSVImport,
  useCreateCSVImport,
} from "../../../../../hooks/queries/locationImports";
import { AppContext } from "../../../../../components/global/appContext";
import LocationsImportNewSkeleton from "./SkeletonNew";

export default function LocationsImportNew() {
  const { t } = useTranslation();
  const { setMessage } = useContext(AppContext);

  const navigate = useNavigate();
  const [abortOnError, setAbortOnError] = useState(false);
  const [CSVData, setCSVData] = useState(null);

  const { data, isLoading } = useGetCSVImport();

  const createCSVImportMutation = useCreateCSVImport({
    onSuccess: (data) => {
      setMessage(t("import.messages.uploadSuccess"));
      navigate(`/places/upload`);
    },
    onError: (error) => {
      console.log(error);
      setMessage(t("import.messages.uploadError"), true);
      console.log(error.response.data);
    },
  });

  function handleCSVUpload() {
    // Create
    createCSVImportMutation.mutate({
      csv: CSVData,
      abort_on_error: abortOnError,
    });
  }

  function handleDownloadSample() {
    // Get current locale from i18n (which should reflect the actual app locale)
    const currentLocale = i18n.language || 'en';
    
    fetch(`/locations/csv_import/download_sample?locale=${currentLocale}`, {
      credentials: 'include', // Important: send cookies/session
      headers: {
        'Accept': 'text/csv'
      }
    })
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.blob();
      })
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'locations_import_sample.csv');
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        alert('Failed to download sample CSV');
        console.error(error);
      });
  }

  if (data) navigate(`/places/upload`);
  if (isLoading) return <LocationsImportNewSkeleton />;
  return (
    <Page>
      <TitleBar
        title={t("import.title")}
        breadcrumbs={[{ content: t("import.breadcrumbs.locations"), url: "/places/locations" }]}
      />
      <Card
        sectioned
        title={t("import.new.title")}
        primaryFooterAction={{
          content: t("import.new.uploadAndContinue"),
          onAction: handleCSVUpload,
          loading: createCSVImportMutation.isLoading,
        }}
      >
        <TextContainer>
          <p>
            {t("import.new.description")}{": "}
            <Button
              plain
              onClick={handleDownloadSample}
            >
              {t("import.new.sampleTemplate")}
            </Button>{" "}
          </p>
          <CsvUpload onCsvLoad={setCSVData} />
          <Checkbox
            label={t("import.new.abortOnError")}
            checked={abortOnError}
            helpText={t("import.new.abortOnErrorHelp")}
            onChange={(value) => setAbortOnError(value)}
          />
        </TextContainer>
      </Card>
      <FooterHelp>
        <Link
          onClick={() => {
            window.Beacon("article", "62e12cc1c35bbc3e190ade4e", {
              type: "modal",
            });
          }}
        >
          {t("import.new.needHelp")}
        </Link>
      </FooterHelp>
    </Page>
  );
}
